import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { insertDivider } from 'utils/jsxUtils';
import { ComponentBaseProps } from 'types';
// UI config
import { CADSidebarWidth } from 'styles/constants';
import AssemblyTreeButton from 'libs/rendering/gltf/components/AssemblyExplorer';
import { useCADManager } from 'hooks';
import { themes } from 'styles/themes/wikifactoryNew';
import { clientStore } from 'apps/client/app';
import { AnnotationButton } from './AnnotationButton';
import { MeasureButton } from './MeasureButton';
import { DfMButton } from './DfMAnalysis';

type CADSidebarProps = {
  extraItems?: ReactNode[];
  isPreview?: boolean;
  mobileMode?: boolean;
} & ComponentBaseProps;

const CADSidebar = observer(
  ({ extraItems = [], className = '', isPreview }: CADSidebarProps) => {
    const {
      shouldShowDfmBtn,
      showAnnotationsOption,
      shouldShowMeasureBtn,
      shouldShowAssemblyTree,
      shouldShowDiffOrMeasurement,
    } = useCADManager();

    const shouldShowAssemblyTreeBtn = shouldShowAssemblyTree && !isPreview;

    const renderItems = insertDivider(
      [
        shouldShowAssemblyTreeBtn && (
          <AssemblyTreeButton key='AssemblyTreeButton' />
        ),
        shouldShowMeasureBtn && shouldShowDiffOrMeasurement && (
          <MeasureButton key='MeasureButton' />
        ),
        showAnnotationsOption() && <AnnotationButton key='AnnotationButton' />,
        shouldShowDfmBtn && <DfMButton key='DfMButton' />,
        ...extraItems,
      ],
      {
        divider: <div className=' my-1' />,
        fromFirst: true,
        regardlessLength: true,
      },
    );

    if (!renderItems?.length) {
      return null;
    }

    return (
      <div
        data-testid='CADSidebar'
        className={`h-full fixed z-[9999] border-x border-b border-wfGrey100 text-black top-0 select-none flex flex-col items-center ${className} `}
        style={{
          padding: 2,
          width: CADSidebarWidth,
          background: themes.color.wfWhite,
          top: clientStore.PageHeaderHeight,
        }}
      >
        {renderItems}
      </div>
    );
  },
);

export { CADSidebar };

export * from './CADButtonWrapper';
